import { TablePagination } from "@mui/material";
import { ObraEstruturaOrganizacional } from "../../../../domain/models/obra_estrutura_organizacional";
import { StyledDataGrid } from "../../Obras_concretagem/components/styled_data_grid";
import { GridColDef } from "@mui/x-data-grid-pro";
import { PaginationProperties } from "../../../../../../common/utils/pagination_property";
import { BaseListModal } from "../../../../../../common/components/base_list_modal";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * EstOrgListaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  columns: GridColDef[];
  items: ObraEstruturaOrganizacional[];
  pagination: PaginationProperties;
  onClose: () => void;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  onNovoItem: () => void;
};

export const EstOrgListaModal = ({
  open,
  saving,
  loading,
  columns,
  items,
  pagination,
  onClose,
  onPageChange,
  onRowsPerPageChange,
  onNovoItem,
}: Props) => {
  return (
    <BaseListModal
      open={open}
      saving={saving}
      loading={loading}
      title="Estrutura Organizacional"
      onClose={onClose}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full flex flex-row justify-end items-center">
          <div>
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
              sx={{ px: 2 }}
              onClick={() => onNovoItem()}>
              Novo
            </PrimaryButton>
          </div>
        </div>

        <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
          <StyledDataGrid
            tableName="obras_informacoes_gerais_1"
            disableColumnMenu={false}
            getRowId={(row: ObraEstruturaOrganizacional) => row.idEstruturaOrganizacional}
            columns={columns}
            loading={loading}
            height='65vh'
            rows={items}
            rowCount={items.length}
            pageSizeOptions={[100]}
            paginationMode="server"
            paginationModel={{
              page: pagination.page - 1,
              pageSize: pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={pagination.totalItems}
            page={pagination.page - 1}
            rowsPerPageOptions={[100]}
            rowsPerPage={pagination.rowsPerPage}
            onPageChange={(_, p) => onPageChange(p)}
            onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />

        </div>
      </div>
    </BaseListModal>
  );
}